
import React from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  white: "#FFFFFF",
  violet: "#5941D9",
  deepViolet: "#3E2DA0",
  lightViolet: "#8466E2",
  veryLightViolet: "#F2EEFF",
  black: "#1A1A1A",
  gray: "#666666",
  lightGray: "#F0F0F0",
  cardShadow: "rgba(89, 65, 217, 0.1)"
};

const Approach = () => {
  return (
    <section 
      style={{ backgroundColor: COLORS.veryLightViolet }}
      className="w-full py-12 px-4 md:py-20 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          
          {/* Animated Illustration */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="relative"
          >
            <div 
              style={{ 
                backgroundColor: COLORS.violet,
                clipPath: "polygon(10% 0%, 90% 0%, 100% 20%, 100% 80%, 90% 100%, 10% 100%, 0% 80%, 0% 20%)"
              }}
              className="absolute -z-10 w-full h-full rounded-xl"
            ></div>
            <motion.img
              initial={{ scale: 0.9, rotate: -2 }}
              whileInView={{ scale: 1, rotate: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              viewport={{ once: true }}
              src="https://ik.imagekit.io/satfy9rkc/Kapil%20Tech%20staffing%20Website/Testing/IVV%20QA.webp"
              alt="IV&V Process Visualization"
              className="w-full "
            />
          </motion.div>
          
          {/* Content Section */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <motion.h1 
              style={{ color: COLORS.black }}
              className="text-3xl md:text-4xl font-bold leading-tight"
              initial={{ y: 20 }}
              whileInView={{ y: 0 }}
              transition={{ delay: 0.3 }}
            >
              KCS Tech's IV&V Approach
            </motion.h1>
            
            <motion.p 
              style={{ color: COLORS.gray }}
              className="text-lg leading-relaxed"
              initial={{ y: 20 }}
              whileInView={{ y: 0 }}
              transition={{ delay: 0.4 }}
            >
              With over 10 years of experience in QA leadership, KCS Tech delivers robust, repeatable, and risk-based IV&V services tailored to your project's complexity, compliance needs, and delivery timelines.
            </motion.p>
            
            <motion.div 
              style={{ color: COLORS.black }}
              className="space-y-4"
              initial={{ y: 20 }}
              whileInView={{ y: 0 }}
              transition={{ delay: 0.5 }}
            >
              <h2 className="text-xl font-semibold">Our IV&V Service Components:</h2>
              
              <div className="space-y-4">
                {[
                  {
                    title: "Requirements Analysis & Traceability",
                    desc: "Ensuring every business need is mapped and testable"
                  },
                  {
                    title: "Risk-Based Test Planning",
                    desc: "Focus QA efforts on high-impact areas and potential failure points"
                  },
                  {
                    title: "Independent QA Strategy & Execution",
                    desc: "Create and manage test cases and validation plans with no vendor influence"
                  },
                  {
                    title: "Defect Analysis and Reporting",
                    desc: "Identify systemic issues with root cause analysis and traceable outcomes"
                  },
                  {
                    title: "Objective Reporting to Stakeholders",
                    desc: "Clear, auditable reporting for compliance and executive transparency"
                  }
                ].map((item, index) => (
                  <motion.div
                    key={index}
                    className="pl-4 border-l-2"
                    style={{ 
                      borderColor: COLORS.violet,
                      borderLeftWidth: "3px"
                    }}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 + index * 0.1 }}
                  >
                    <h3 
                      style={{ color: COLORS.deepViolet }}
                      className="font-bold text-lg mb-1"
                    >
                      {item.title}
                    </h3>
                    <p 
                      style={{ color: COLORS.gray }}
                      className="text-base"
                    >
                      {item.desc}
                    </p>
                  </motion.div>
                ))}
              </div>
            </motion.div>
            
            <motion.div
              style={{ 
                color: COLORS.gray,
                borderTop: `1px solid ${COLORS.lightViolet}`
              }}
              className="pt-6"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <p>All services are aligned with our proprietary <span style={{ color: COLORS.deepViolet }} className="font-bold">Quality Management Office</span>—designed for scalable, audit-ready quality assurance.</p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Approach